import React, { Component } from "react";
import ReactHtmlParser from "react-html-parser";
import { StyledTitle } from "../App";
import styled from "styled-components";
import { Card } from "./styles/Card";
import { getFaqsCedula } from "../../requests/faqs";
import config from "../../config";

class Faqs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cedulas: []
    };
  }

  componentDidMount() {
    this.renderFaqs();
  }

  renderFaqs = async () => {
    try {
      let res = await getFaqsCedula();
      let cedulas = res.data;

      this.setState({ cedulas });
    } catch (err) {
      console.log(err);
    }
  };
  render() {
    return (
      <>
        <br />
        <StyledTitle className="text-center my-5">
          Preguntas Frecuentes
        </StyledTitle>

        <div className="container">
          {this.state.cedulas.map((cedula, key) => (
            <Card key={key}>
              <a
                style={{ color: "#2fbcbb" }}
                href={`${config.tramitaYa}/preguntas-frecuentes/${cedula.id}`}>
                <StyledTitle>{cedula.title}</StyledTitle>
              </a>
              <div className="content">
                <TextContent>
                  {ReactHtmlParser(`${cedula.body.substring(0, 450)} ...`)}
                </TextContent>
              </div>
              <a
                href={`${config.tramitaYa}/preguntas-frecuentes/${cedula.id}`}
                style={{ color: "#2fbcbb" }}>
                Leer mas sobre: {cedula.title}
              </a>
            </Card>
          ))}
        </div>

        <div className="text-center mt-4">
          <button className="btn" style={styles.buttonNext}>
            <a
              target="_blank"
              style={styles.buttonViewMore}
              href={`${config.tramitaYa}/contacto#preguntas-frecuentes`}>
              Ver Mas
            </a>
          </button>
        </div>
      </>
    );
  }
}

const TextContent = styled.p`
  font-family: "Montserrat";
  color: #495056 !important;
  font-size: 15px;
  text-align: justify;
  padding-left: 10px;
  padding-right: 10px;
`;

const styles = {
  buttonNext: {
    borderRadius: "3px",
    fontSize: 13,
    boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.0)",
    padding: "10px 40px",
    fontFamily: "Montserrat",
    fontWeight: 300,
    backgroundColor: "#2fbcbb",
    marginBottom: "20px"
  },
  buttonViewMore: {
    display: "block",
    color: "white"
  }
};

export default Faqs;
